import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            value: '',
            options: []
        };
    },
    created() {
        this.value = this.params.value;
        this.options = this.GLOBAL[this.params.column.colId];
    },
    mounted() {
        Vue.nextTick(() => {
            // need to check if the input reference is still valid - if the edit was cancelled before it started there
            // wont be an editor component anymore
            if (this.$refs.input) {
                this.$refs.input.focus();
            }
        });
    },
    methods: {
        onChange() {
            this.value = this.value;
        },
        getValue() {
            return this.value;
        }
    },
    template: `
        <el-select
        v-model="value"
        placeholder="Please pick."
        @change="onChange" >
            <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item"
            >
            </el-option>
        </el-select>
    `
});



// WEBPACK FOOTER //
// ./src/views/my/planTemplate/components/selectEditor.js